/**
 * @deprecated use pixels or the unit of your choice directly
 * @param px
 * @returns {string}
 */
export function pxToRems(px) {
  return `${px / 16}rem`;
}

/**
 * @deprecated use pixels or the unit of your choice directly
 *
 * @param px
 * @returns {string}
 */
export function pxToEms(px) {
  return `${px / 16}em`;
}

/**
 * @deprecated use pixels or the unit of your choice directly
 *
 * @param px
 * @returns {string}
 */
export function pxToUnit(px) {
  return `${px / 16}`;
}